import { keyframes, styled } from "goober";

export const ActivityActions = styled("div")`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export const ActivityMenuOpener = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 9999px;
  color: var(--text-primary);
  cursor: pointer;

  &:hover {
    background: var(--alpha4);
  }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.2; }
`;

export const ActivityStatusDot = styled("span")`
  display: inline-block;
  flex: none;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--gray-400);

  &[data-running="true"] {
    animation: ${pulse} 1.1s ease-in-out infinite;

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  }
`;
